import { Routes, Route } from 'react-router-dom';
import InterestForm from './InterestForm';
import ThankYou from './ThankYou';
import NotFound from './NotFound';
import OptInPage from './OptInPage';
import OptInDone from './OptInDone';
import ScreeningPage from './ScreeningPage';
import ScreeningDone from './ScreeningDone';
import BookingPage from './BookingPage';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<InterestForm />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/optin/done" element={<OptInDone />} />
        <Route path="/optin/:token" element={<OptInPage />} />
        <Route path="/s/done" element={<ScreeningDone />} />
        <Route path="/s/:token" element={<ScreeningPage />} />
        <Route path="/book/:token" element={<BookingPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
